module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point05_03_sunset-6cdf05ec3df58e818c9fe6a02eee11be.jpg";